import { Link, useLocation, useNavigate } from "react-router-dom";
import { Linkedin } from "lucide-react";
import { scrollToSection } from "@/components/Navbar";

export default function Footer() {
  const location = useLocation();
  const navigate = useNavigate();

  const handleNav = (hash) => {
    if (location.pathname !== "/") navigate("/", { state: { scrollTo: hash } });
    else scrollToSection(hash);
  };

  return (
    <footer className="border-t border-white/10 bg-navy-800/40" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          <img src="/assets/logo-light.png" alt="GENOUM GROUP" className="h-11 w-auto" />
          <p className="text-sm text-slate-400 leading-relaxed mt-6 max-w-xs">
            A diversified group pioneering energy, infrastructure and advanced medical
            technology from India.
          </p>
        </div>
        <div>
          <p className="font-mono-accent text-[10px] tracking-[0.25em] uppercase text-slate-500 mb-5">Navigate</p>
          <div className="flex flex-col gap-3">
            {[
              { label: "Business Divisions", href: "#divisions" },
              { label: "Who We Are", href: "#who-we-are" },
              { label: "Leadership", href: "#leadership" },
              { label: "Contact", href: "#contact" },
            ].map((link) => (
              <button
                key={link.href}
                onClick={() => handleNav(link.href)}
                className="text-left text-sm text-slate-400 hover:text-neon transition-colors duration-300 w-fit"
                data-testid={`footer-link-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {link.label}
              </button>
            ))}
            <Link
              to="/projects"
              className="text-sm text-slate-400 hover:text-neon transition-colors duration-300 w-fit"
              data-testid="footer-link-projects"
            >
              Projects
            </Link>
            <Link
              to="/careers"
              className="text-sm text-slate-400 hover:text-neon transition-colors duration-300 w-fit"
              data-testid="footer-link-careers"
            >
              Careers
            </Link>
          </div>
        </div>
        <div>
          <p className="font-mono-accent text-[10px] tracking-[0.25em] uppercase text-slate-500 mb-5">Reach Us</p>
          <div className="text-sm text-slate-400 space-y-2">
            <p>+91 72059 25473 · +91 99378 65473</p>
            <p>info.genoumgroup@gmail.com</p>
            <a
              href="https://www.linkedin.com/in/genoum-group-5aa346428"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 hover:text-neon transition-colors duration-300 w-fit"
              data-testid="footer-linkedin-link"
            >
              <Linkedin className="w-4 h-4 text-electric" /> LinkedIn — Genoum Group
            </a>
            <p className="pt-3">Bhubaneswar · Balasore · Ghaziabad</p>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="font-mono-accent text-[10px] tracking-[0.2em] uppercase text-slate-600">
            © {new Date().getFullYear()} Genoum Private Limited. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
